<template>
  <Modal @close="$emit('close')" :classes="'col-md-4'" :title="title">
    <div slot="body">
      <div class="container">
        <div class="row">
          <div class="col text-center">
            <button class="button logo mr-2" @click="$emit('delete')">
              Eliminar
            </button>
            <button class="button primary" @click="$emit('close')">
              Cancelar
            </button>
          </div>
        </div>
      </div>
    </div>
  </Modal>
</template>

<script>
import Modal from "@/components/Modal";

export default {
  name: "DeleteModal",
  props: {
    title: {
      type: String,
      default: "Desea eliminar este comentario?",
    },
  },
  components: {
    Modal,
  },
};
</script>
